export const InfoFilled = ({ size = "14" }: { size?: string }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 15 14"
      fill="none"
    >
      <g clipPath="url(#clip0_2492_417)">
        <path
          d="M14.5 7C14.5 8.38447 14.0895 9.73785 13.3203 10.889C12.5511 12.0401 11.4579 12.9373 10.1788 13.4672C8.8997 13.997 7.49224 14.1356 6.13437 13.8655C4.7765 13.5954 3.52922 12.9287 2.55026 11.9497C1.57129 10.9708 0.904603 9.7235 0.634506 8.36563C0.36441 7.00777 0.503033 5.6003 1.03285 4.32122C1.56266 3.04213 2.45987 1.94888 3.61101 1.17971C4.76216 0.410543 6.11553 0 7.5 0C9.3559 0.0020073 11.1352 0.74015 12.4475 2.05247C13.7599 3.36479 14.498 5.1441 14.5 7ZM8.66667 7C8.66667 6.69058 8.54375 6.39384 8.32496 6.17504C8.10617 5.95625 7.80942 5.83333 7.5 5.83333H6.33334V7H7.5V11.0833H8.66667V7ZM7.5 2.91667C7.32695 2.91667 7.15777 2.96799 7.01388 3.06413C6.86999 3.16028 6.75784 3.29693 6.69161 3.45682C6.62538 3.6167 6.60805 3.79264 6.64182 3.96237C6.67558 4.1321 6.75891 4.28801 6.88129 4.41039C7.00366 4.53276 7.15957 4.61609 7.3293 4.64985C7.49903 4.68362 7.67497 4.66629 7.83485 4.60006C7.99474 4.53384 8.13139 4.42168 8.22754 4.27779C8.32369 4.1339 8.375 3.96473 8.375 3.79167C8.375 3.5596 8.28282 3.33704 8.11872 3.17295C7.95463 3.00885 7.73207 2.91667 7.5 2.91667Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_2492_417">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
